<template>
  <div class="row mt-2">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h2 class="mb-0 text-gray-800">Painel Analítico do Gestor</h2>
        <b-button-group>
          <b-button variant="outline-dark"
                    size="sm"
                    to="/dashboard/relatorios">
            Relatórios <i class="fas fa-external-link-alt"></i>
          </b-button>
        </b-button-group>
      </div>
    </div>
    <div class="col-md-12">
      <router-view/>
    </div>
  </div>
</template>
<script>
export default {
  name: "GestorAnalytics",
  metaInfo() {
    return {
      title: this.$i18n.t("Painel Analítico do Gestor"),
    };
  },
};
</script>


